import React, { FormEvent, useEffect, useState } from "react";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Link, useNavigate } from "react-router-dom";
import { getApiErrorMessage } from "../../store/api/baseApi";
import {
  getStoredClientUser,
  useLoginClientMutation,
} from "../../store/api/clientAuthApi";
import "./client.css";

const ClientLoginPage = () => {
  const navigate = useNavigate();
  const [loginClient, { isLoading }] = useLoginClientMutation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (getStoredClientUser()) {
      navigate("/client", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");

    try {
      await loginClient({ email, password }).unwrap();
      navigate("/client", { replace: true });
    } catch (apiError) {
      setError(getApiErrorMessage(apiError as FetchBaseQueryError));
    }
  };

  return (
    <section className='client-login-shell'>
      <div className='client-login-card'>
        <p className='client-login-kicker mb-2'>Client Access</p>
        <h1 className='h3 mb-2'>Login to view your project progress</h1>
        <p className='text-muted mb-4'>
          Use your client account to open the Dialin24 portal and see only your
          assigned projects, progress tasks, and delivery updates.
        </p>

        <form onSubmit={handleSubmit}>
          <div className='mb-3'>
            <label htmlFor='clientEmail' className='form-label fw-semibold'>
              Email
            </label>
            <input
              id='clientEmail'
              type='email'
              className='form-control'
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>
          <div className='mb-3'>
            <label htmlFor='clientPassword' className='form-label fw-semibold'>
              Password
            </label>
            <input
              id='clientPassword'
              type='password'
              className='form-control'
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          {error ? <div className='alert alert-danger'>{error}</div> : null}

          <div className='d-grid gap-2'>
            <button
              type='submit'
              className='btn btn-primary btn-lg'
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Open Client Panel"}
            </button>
            <Link to='/' className='btn btn-outline-secondary'>
              Back to Website
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ClientLoginPage;
